<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <section id="profile" :class="$style.sectionProfile" class="section">
    <div class="container">
      <BaseSectionTitle title="品牌介紹" class="text-center" />
      <div class="sectionProfile__content bg-gray-2" v-html="text"> </div>
    </div>
  </section>
</template>
<style lang="scss" module>
.sectionProfile {
  :global {
    .row {
      align-items: center;
    }

    .sectionProfile {
      &__content {
        padding: 3.75rem;
        line-height: 2;

        @include max-md {
          padding: 1rem;
        }
      }

      &__img {
      }

      &__text {
        padding-left: 2rem;
      }
    }
  }
}
</style>
